import { useEffect, useRef } from "react";
import {
  DASHBOARD_DATE_WINDOW_EVENT,
  readDashboardDateWindow,
  type DashboardDateWindowV1,
} from "../utils/dashboardDateWindowStorage";

/**
 * Applies shared date-window state when another view (or tab) updates localStorage.
 */
export function useDashboardDateWindowListener(apply: (p: DashboardDateWindowV1) => void): void {
  const applyRef = useRef(apply);
  applyRef.current = apply;

  useEffect(() => {
    const run = () => {
      const next = readDashboardDateWindow();
      if (next) applyRef.current(next);
    };
    window.addEventListener(DASHBOARD_DATE_WINDOW_EVENT, run);
    window.addEventListener("storage", run);
    return () => {
      window.removeEventListener(DASHBOARD_DATE_WINDOW_EVENT, run);
      window.removeEventListener("storage", run);
    };
  }, []);
}
